import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMMAccountModel } from '@apps-common/types/my-monitoring/account'

export const QUERY_KEY_MY_MONITORING_GET_ACCOUNT = () => ['getMyMonitoringAccount'].filter(Boolean)

const getMyAccount = async (): Promise<IMMAccountModel> => axios.get(`/my-monitoring/account/GetMyAccount`).then((res) => res.data?.data)

type QueryFnType = typeof getMyAccount

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useMyMonitoringGetAccount = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_ACCOUNT(),
    queryFn: () => getMyAccount()
  })
